/* global axios */
import ApiClient from '../ApiClient';

class StudioProject extends ApiClient {
  constructor() {
    super('ai/projects', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, { project: data });
  }

  update(id, data) {
    return axios.put(`${this.url}/${id}`, { project: data });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  restore(id) {
    return axios.post(`${this.url}/${id}/restore`);
  }

  copyVersion(projectId, versionId) {
    return axios.post(`${this.url}/${projectId}/versions/${versionId}/copy`);
  }

  discardVersion(projectId, versionId) {
    return axios.delete(`${this.url}/${projectId}/versions/${versionId}`);
  }

  startHomologation(projectId, versionId) {
    return axios.post(
      `${this.url}/${projectId}/versions/${versionId}/start_homologation`
    );
  }

  approveVersion(projectId, versionId) {
    return axios.post(`${this.url}/${projectId}/versions/${versionId}/approve`);
  }

  rejectVersion(projectId, versionId, { reason }) {
    return axios.post(`${this.url}/${projectId}/versions/${versionId}/reject`, {
      reason,
    });
  }

  // `syncCampaigns` = recompilar as jornadas de campanha logo após o cutover
  // (o diálogo do Studio pergunta). Ausente = comportamento de sempre.
  activateVersion(projectId, versionId, options = {}) {
    const payload =
      options.syncCampaigns === undefined
        ? {}
        : { sync_campaigns: options.syncCampaigns };
    return axios.post(
      `${this.url}/${projectId}/versions/${versionId}/activate`,
      payload
    );
  }

  updateVersion(projectId, versionId, data) {
    return axios.patch(`${this.url}/${projectId}/versions/${versionId}`, {
      version: data,
    });
  }
}

export default new StudioProject();
